export default __webpack_public_path__ + "static/media/LIFF20GIF.b5553d41.gif";